import React, { Component, useState } from 'react';
import { Navbar, Form, Nav, Dropdown, Image, Container } from 'react-bootstrap';
import './Nav.css';
import LogoWirebit from '../../../Images/Logos/LogoAzul.png';
import MX from '../../../Images/ES-language.png'
import US from '../../../Images/EN-language.png'
import icons from '../../Landing/icons.json'
import translate from '../../../translate'

let sections, navLi
class NavBarComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedLanguage:this.props.data.lan,
      text: translate[this.props.data.lan].Landing.Navbar,
    }
  }

  componentDidMount(){
    this.highlightOnScroll()
  }

  highlightOnScroll(){
    let timer = null;
    sections = window.document.querySelectorAll('.section-container');
    navLi = window.document.querySelectorAll('.highlightable');
    window.addEventListener('scroll', ()=>{
      if(timer !== null) {
        clearTimeout(timer);
      }
      timer = setTimeout(function() {
        let current = '';
        sections.forEach((section, i) => {
          const sectionTop = section.offsetTop;
          const pageYOffset = window.pageYOffset
          const halfHeight = window.innerHeight / 2
          if((pageYOffset + halfHeight) >= sectionTop){
            current = section.getAttribute('id')
          }
        });

        navLi.forEach((li, i) => {
          if(li.classList.contains(current)){
            li.classList.add('active')
          } else {
            li.classList.remove('active')
          }
        });
      }, 2);
    })
  }

  scrollTo(element){
    this.props.data.data.history.push('/')
    if(element === 'servicios') { 
      navLi[0].classList.add('active'); 
      window.scrollTo({
        top: 0,
        left: 0,
      })
    }
    setTimeout(function () {
      sections = window.document.querySelectorAll('.section-container');
      var elmntToView = window.document.getElementById(element);
      if(elmntToView)
        elmntToView.scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"});
    }, 100);
  }

  navToFaq(){
    navLi.forEach((li, i) => {
      li.classList.remove('active')
    });
    this.props.history.push('/faq')
    window.scroll(0, 0);
  }

  render() {
    return (
      <div style={{overflow: "hidden" }}>
        <Navbar className="containerNav Navbar" expand="lg" collapseOnSelect>
          <Container>
            <Navbar.Brand onClick={()=>this.scrollTo('nosotros')} href="#" className="logo">
              <Image src={LogoWirebit} className='logoImg' />
              <Image src={LogoWirebit} className='logoImg2' />
            </Navbar.Brand>
            <Navbar.Toggle className='navBarTest' aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav>
                <Nav.Link onClick={()=>this.scrollTo('servicios')} href="#" className="highlightable nav-link servicios">{this.state.text.servicios}</Nav.Link>
                <Nav.Link onClick={()=>this.scrollTo('tarjeta')} href="#" className="highlightable nav-link tarjeta">{this.state.text.tarjeta}</Nav.Link>
                <Nav.Link onClick={()=>this.props.data.data.history.push('/faq')} href="#" className="highlightable nav-link faq">{this.state.text.faq}</Nav.Link>
                <Nav.Link onClick={()=>this.scrollTo('descarga')} href="#" className="highlightable nav-link descarga">{this.state.text.descarga}</Nav.Link>
                <div className="vertical-line-divider"/>
                <Nav.Link className="nav-link">
                  <a onClick={()=> this.props.data.data.history.push('/login')} style={{textDecoration:'none', color: '#4565FF'}}>{this.state.text.LogIn}</a>
                </Nav.Link>
                <Nav.Link className="nav-link" style={{borderBottom:'2px solid transparent'}}>
                  <button className="wirebit-btn-navbar" onClick={()=>this.props.data.data.history.push('/register')} href="#" style={{textDecoration:'none',color:'#1f1f1f'}}>{this.state.text.Btn_SignUp}</button>
                </Nav.Link>
                <Dropdown className='dropdown-language theLanguageDropdownStyle'>
                  <Dropdown.Toggle as={this.CustomToggle} id="dropdown-custom-components ">
                    <Image src={(this.state.selectedLanguage == 'en')?US:MX} style={{width:'2em'}}></Image>
                    <div dangerouslySetInnerHTML={{__html:icons['DownArrow']}} className='icon-container' />
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item style={{textDecoration: 'none'}} eventKey="1" onClick={()=>{localStorage.setItem("lan", 'es'); this.setState({selectedLanguage:'es',  text: translate['es'].Landing.Navbar}); this.props.changeLan('es'); window.lan='es'}}> <Image src={MX} style={{width:'1.5em'}}/>{this.state.text.L_spanish}</Dropdown.Item>
                    <Dropdown.Item style={{textDecoration: 'none'}} eventKey="2" onClick={()=>{localStorage.setItem("lan", 'en'); this.setState({selectedLanguage:'en',  text: translate['en'].Landing.Navbar}); this.props.changeLan('en'); window.lan='en'}}> <Image src={US} style={{width:'1.5em'}}/>{this.state.text.L_english}</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </Nav>
              <Form inline>
              </Form>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </div>
    );
  }
}

export default NavBarComponent;
